import { promises } from '../../data/siteContent';

function PromiseSection() {
  return (
    <section className="block" id="promise">
      <div className="wrap">
        <div className="promise-panel reveal">
          <span className="eyebrow">이동은의 약속</span>
          <h2>“저에게 관리받으셔야 하는 이유”</h2>
          <div className="promise-list">
            {promises.map(([title, body]) => (
              <div className="promise-item" key={title}>
                <span className="check" aria-hidden="true">✓</span>
                <div><b>{title}</b><span>{body}</span></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PromiseSection;
